"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("../../../Button"));
const constants_1 = require("../../data/constants");
const store_1 = require("../../context/store");
const useRate_1 = __importDefault(require("../../hooks/useRate"));
const setCryptoValue_1 = __importDefault(require("../../helpers/setCryptoValue"));
const actions_1 = require("../../context/actions");
const Checkbox_1 = __importDefault(require("../Checkbox"));
const CryptoInput_1 = __importDefault(require("../CryptoInput"));
const FiatSelect_1 = __importDefault(require("../FiatSelect"));
const ProviderSelectSell_1 = __importDefault(require("../ProviderSelectSell"));
const useGeoLocation_1 = __importDefault(require("../../hooks/useGeoLocation"));
const styled_1 = require("./styled");
const SellContent = () => {
    (0, useGeoLocation_1.default)();
    const dispatch = (0, store_1.useDispatch)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { selectedCrypto, selectedFiat, autoSelectProvider, geoLocation } = (0, store_1.useTrackedState)();
    const baseFiatRate = (0, useRate_1.default)(selectedFiat, constants_1.DEFAULT_FIAT_CODE);
    const [openProvider, setOpenProvider] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!selectedFiat || !baseFiatRate)
            return;
        (0, setCryptoValue_1.default)(dispatch, selectedCrypto.code, selectedFiat, baseFiatRate);
    }, [selectedCrypto, selectedFiat, baseFiatRate, dispatch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.SellContentWrapper, null,
            react_1.default.createElement(CryptoInput_1.default, null),
            react_1.default.createElement(FiatSelect_1.default, { label: formatMessage({ id: "sell.local-currency" }) }),
            react_1.default.createElement("div", { style: { marginTop: 24 } },
                react_1.default.createElement(Button_1.default, { type: "button", design: "primary", fullWidth: true, onClick: () => {
                        setOpenProvider(true);
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "sell.crypto.button", values: { crypto: selectedCrypto.code } }))),
            ((geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.alpha2) !== "GB") && (react_1.default.createElement("div", { style: { marginTop: 32, textAlign: 'left' } },
                react_1.default.createElement(Checkbox_1.default, { checked: autoSelectProvider, onChange: (e) => {
                        dispatch({
                            type: actions_1.CONTEXT_ACTIONS.SET_AUTOSELECT_PROVIDER,
                            payload: e.target.checked,
                        });
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "main.auto-select" }))))),
        react_1.default.createElement(ProviderSelectSell_1.default, { open: openProvider, setOpen: setOpenProvider })));
};
exports.default = SellContent;
//# sourceMappingURL=SellContent.js.map